import React from 'react';
import BodyComponent from '../base/body';

export default function ListBody(props) {
  return <BodyComponent component="div" {...props} />;
}
